import React from 'react';
import Lottie from 'lottie-react';
import buildingAnimationData from './building-animation.json';

const BuildingAnimation = () => {
  return (
    <div className="building-animation">
      <Lottie
        animationData={buildingAnimationData}
        loop={true}
        autoplay={true}
        style={{
          height: '600px',
          width: '600px'
        }}
      />
    </div>
  );
};

export default BuildingAnimation;